import React from "react";
import CreditDebitAmount from "../../../../../components/transactions/CreditDebitAmount";
import { staffApi } from "../../../../../services/index";

const CreditDebit = () => {
  return (
    <CreditDebitAmount
      getUser={staffApi.getUserByAccountNumber}
      updateAmount={staffApi.updateAmount}
    />
  );
};

export default CreditDebit;
